import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "./styles.css";

interface ScaleControlProps {
  position?: "topleft" | "topright" | "bottomleft" | "bottomright";
  maxWidth?: number;
  metric?: boolean;
  imperial?: boolean;
}

export function ScaleControl({
  position = "bottomleft",
  maxWidth = 100,
  metric = true,
  imperial = false,
}: ScaleControlProps) {
  const map = useMap();

  useEffect(() => {
    const scale = L.control.scale({
      position,
      maxWidth,
      metric,
      imperial,
    }) as L.Control;

    map.addControl(scale);

    return () => {
      map.removeControl(scale);
    };
  }, [map, position, maxWidth, metric, imperial]);

  return null;
}
